import { merchantServiceGraphql } from "../config/Config";
import gql from "graphql-tag";

export const getTransactionByContract = async(merchantId, startDate, endDate, page, rowsPerPage, orderBy, order) => {
    const variables = {
        "filter": {
            "MerchantID": merchantId,
            "StartDate": startDate,
            "EndDate": endDate
        },
        "page": page,
        "perPage": rowsPerPage,
        "sortField": orderBy,
        "sortOrder": order
    }
    const TRANSACTION = gql`
        query Transactions($page: Int, $perPage: Int, $sortField: TransactionSortField, $sortOrder: String, $filter: TransactionWhereInput) {
            getTransactionByContract(page: $page, perPage: $perPage, sortField: $sortField, sortOrder: $sortOrder, filter: $filter) {
                id
                description
                transdate
                transtypeid
                targetcontractorig
                grossamount
                feeamount
                netamount
                accountcurrency
                paymentdate
                paymentstatus
                issbank
                cardips
                transactionstatus
            }
        }
    `
    const respone = await merchantServiceGraphql.request(TRANSACTION, variables);
    return respone.getTransactionByContract;
    
}
export const getTransactionByMerchant = async(terminalId, startDate, endDate, page, rowsPerPage, orderBy, order) => {
    const variables = {
        "filter": {
            "TerminalID": terminalId,
            "StartDate": startDate,
            "EndDate": endDate
        },
        "page": page,
        "perPage": rowsPerPage,
        "sortField": orderBy,
        "sortOrder": order
    }
    const TRANSACTION = gql`
        query Transactions($page: Int, $perPage: Int, $sortField: TransactionSortField, $sortOrder: String, $filter: TransactionWhereInput) {
            getTransactionByMerchant(page: $page, perPage: $perPage, sortField: $sortField, sortOrder: $sortOrder, filter: $filter) {
                id
                description
                transdate
                transtypeid
                targetcontractorig
                grossamount
                feeamount
                netamount
                accountcurrency
                paymentdate
                paymentstatus
                issbank
                cardips
                transactionstatus
            }
        }
    `
    const respone = await merchantServiceGraphql.request(TRANSACTION, variables);
    return respone.getTransactionByMerchant;
    
}